import * as React from 'react';
import { APPLICATION_TASK_TAB_PAD_HEIGHT, COLLAPSED_COLUMN_WIDTH, COLLAPSED_ROW_HEIGHT, HEADER_HEIGHT, SIDEBAR_WIDTH } from '../../layout';
import { useGroupBy, useOrganizations, useReleases, useRowHeights } from '../../state/context';
import SolutionRows from './SolutionRows';
import OrganizationRows from './OrganizationRows';
import { onSelectTaskChange } from '../../state';

const Rows = () => {
  const releases = useReleases();
  const organizations = useOrganizations();
  const rowHeights = useRowHeights();
  const [groupBy] = useGroupBy();
  const innerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    return onSelectTaskChange((task) => {
      if (!innerRef.current || !task) {
        return;
      }

      const solution = innerRef.current.querySelector(`[data-solution-id="${task.solutionId}"]`) as HTMLDivElement;

      if (!solution) {
        return;
      }

      window.scrollTo({
        top: solution.offsetTop - HEADER_HEIGHT,
        left: solution.offsetLeft,
        behavior: 'smooth',
      });
    });
  }, []);

  React.useEffect(() => {
    const handleScroll = () => {
      if (innerRef.current) {
        innerRef.current.style.transform = `translate(-${window.scrollX}px, -${window.scrollY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const width = React.useMemo(
    () => (releases.length * COLLAPSED_COLUMN_WIDTH) + SIDEBAR_WIDTH,
    [releases.length],
  );

  const height = React.useMemo(
    () => {
      let value = (
        HEADER_HEIGHT +
        Object.values(rowHeights).reduce((acc, curr) => acc + curr, 0)
      );

      if (groupBy === 'organization') {
        value += APPLICATION_TASK_TAB_PAD_HEIGHT;
      }

      return value;
    },
    [organizations.length, rowHeights],
  );

  return (
    <div
      className="fixed bottom-0 right-0 overflow-hidden bg-gray-100 min-h-full"
      style={{
        top: `${HEADER_HEIGHT}px`,
        left: `${SIDEBAR_WIDTH}px`,
      }}
    >
      <div style={{ width: `${width}px`, height: `${height}px` }} ref={innerRef}>
        {groupBy === 'solution' && (
          <SolutionRows />
        )}
        {groupBy === 'organization' && (
          <OrganizationRows />
        )}
      </div>
    </div>
  );
};

export default Rows;
